import React, { FC, memo, useEffect } from 'react';

import { useApi, getApiUrl } from 'utils/api/useApi';
import {
  ReceivedInterventionPlanDetailsResponse,
  ReceivedInterventionPlanResponse,
} from 'utils/api/inbox';
import usePrefix from 'utils/usePrefix';
import { PaginatedList } from 'utils/api';

import NoticeContent from 'components/NoticeContent';
import Loader from 'components/Loader';

import FavoriteStar from '../FavoriteStar';

const url = getApiUrl('/interveners/me/intervention-plans');

interface Props {
  id: number;
  fetchData: () => Promise<void | PaginatedList<ReceivedInterventionPlanResponse[]>>;
}

const InterventionPlan: FC<Props> = ({ id, fetchData }) => {
  const t = usePrefix('InterventionPlans');

  const { data, isLoading } = useApi<ReceivedInterventionPlanDetailsResponse>(`${url}/${id}`, {
    method: 'GET',
  });

  useEffect(() => {
    if (data) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (isLoading || !data) return <Loader label={t('loading')} />;

  return (
    <NoticeContent {...data.details} isRating noticeId={id} headerAction={<FavoriteStar planId={id} />} />
  );
};

export default memo(InterventionPlan);
